import Checkbox from '@/app/components/common/Checkbox'
import Text from '@/app/components/common/Text'
import { STAY_OPTIONS } from '@/app/constants'
import { Filters } from '@/app/types'
import { HotelContentAccommodationTypeEnum } from '@/app/types/skyscanner-wrapper-api'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import { FC, useMemo } from 'react'

interface StayOptionsFilterProps {
	localValue: Filters
	showAllStayOptions: boolean
	handleStayOptionChange: (optionId: number, name: string) => void
	toggleStayOptionsView: () => void
	availableFilters: {
   		id: number;
    	name: string;
	}[],
}

const StayOptionsFilter: FC<StayOptionsFilterProps> = ({
	localValue,
	showAllStayOptions,
	handleStayOptionChange,
	toggleStayOptionsView,
	availableFilters,
}) => {

	const shouldExpandList = useMemo(() => {
		return localValue.stayOptions.some(
			(optionId) =>
				availableFilters.findIndex((option) => option.id === optionId) >= 5
		)
	}, [localValue.stayOptions, availableFilters])

	const t = useTranslations('Keywords')
	const tOptions = useTranslations('Filters.StayOptions')

	const optionsToShow =
		shouldExpandList || showAllStayOptions
			? availableFilters
			: availableFilters.slice(0, 5)

	if (availableFilters.length === 0) return null

	return (
		<div className="hotel-list-filters__section">
			<Text size="base" font={'bold'} className="mb-3 inline-block">
				{t('stayOptionsFilter')}
			</Text>
			<ul className="hotel-list-filters__stay-options">
				{optionsToShow.map(({ id, name }) => {
					const isChecked = localValue.stayOptions.includes(id)
					const labelText = tOptions(name)

					return (
						<div
							key={id}
							className="hotel-list-filters__stay-options-item hotel-list-filters__item"
						>
							{/* Desktop: Regular checkbox */}
							<div className="xl:block hidden w-full">
								<Checkbox
									variant="main-dark"
									checked={isChecked}
									testId={`stay-option-${id}`}
									onChange={() => handleStayOptionChange(id, name)}
									labelRight={labelText}
									bold={false}
								/>
							</div>
							{/* Mobile: Pill button */}
							<button
								type="button"
								className={classNames(
									'hotel-list-filters__pill-checkbox xl:hidden',
									{
										'pill-checkbox--active': isChecked,
									}
								)}
								onClick={() => handleStayOptionChange(id, name)}
								data-test-id={`stay-option-${id}`}
							>
								<span className="pill-checkbox__text">{labelText}</span>
							</button>
						</div>
					)
				})}
			</ul>
			{!shouldExpandList && availableFilters.length > 5 && (
				<button
					onClick={toggleStayOptionsView}
					className="text-secondary font-medium text-sm hover:underline mt-2 mb-2 max-sm:underline"
				>
					{showAllStayOptions ? t('seeLess') : t('seeMore')}
				</button>
			)}
		</div>
	)
}

export default StayOptionsFilter
